import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=35d638c6&scoped=true&"
var script = {}
import style0 from "@/assets/css/wcms.css?vue&type=style&index=0&id=35d638c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d638c6",
  null
  
)

export default component.exports